<template>
    <div
        class="divider"
        :class="[
            `thickness_${thickness}`,
            `top_${topMargin}`,
            `bottom_${bottomMargin}`,
            `color_${color}`,
        ]"></div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { Color, Margin, Thickness } from './Divider.interfaces';

    export default defineComponent({
        name: 'Divider',
        props: {
            topMargin: {
                type: String as PropType<Margin>,
                default: 'none',
            },
            bottomMargin: {
                type: String as PropType<Margin>,
                default: 'none',
            },
            thickness: {
                type: String as PropType<Thickness>,
                default: '1',
            },
            color: {
                type: String as PropType<Color>,
                default: 'black',
            },
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'Divider.scss';
</style>
